import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetTransactionBO, saveTransActionBO } from './transaction-menu-modal';
import { BulkT2025UpdateBO } from '../evvtimesheet/evvtimesheet.model';
@Injectable({
  providedIn: 'root'
})
export class TransactionMenuService {
   
 
  constructor(private http: HttpClient, public errorService: ErrorService) { }

 
  SaveTransactions(saveList: saveTransActionBO): Observable<any> {
    let url = "api/TransactionMenu/SaveOrUpdateTransacMenu";
    return this.http.post(url, saveList, { observe: 'response',responseType: "text"},).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
    )
}
SaveMinmumAmount(saveList: saveTransActionBO): Observable<any> {
  let url = "api/TransactionMenu/SaveTransacMenu";
  return this.http.post(url, saveList, { observe: 'response',responseType: "text"},).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
  )
}


// DeleteListTransac(menuId: any): Observable<any> {
//   let url = "api/TransactionMenu/DeleteTransacMenu"
//   return this.http.delete(url+menuId, { observe: 'response', responseType: "text" },).pipe(
//     map(data => data.body),
//     catchError(this.errorService.handleError)
//   )
// }


DeleteListTransac(menuId: any): Observable<any> {
  let url = "api/TransactionMenu/DeleteTransacMenu/" + menuId;
  return this.http.delete(url, { observe: 'response', responseType: "text" },).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}


GetClientDropdown(): Observable<any> {
  let url = "api/Client/clientDropDown?";
  return this.http.get<any>(url, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

getAuth(paramsData: URLSearchParams): Observable<any> {
  let url = "api/TransactionMenu/GetAuthorizationList?";
  return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
  
GetAllClientDropDown(): Observable<any> {
  let url = "api/Client/GetAllClientDropDown?";
  return this.http.get<any>(url, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
} 


getServicedropDown(): Observable<any> {
  let url = "api/TransactionMenu/GetTransactionService?";
  return this.http.get<any>(url , { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

   //==============================get employee permission==========================================//
   getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  exportcsv(getBO: GetTransactionBO): Observable<any> {

    let url = "api/TransactionMenu/GetTransacMenuListExport";

    return this.http.post(url, getBO, { observe: 'response' }).pipe(

      map(data => data.body),
      catchError(this.errorService.handleError))


  }


  updateMulitpleTransactions(getBO: BulkT2025UpdateBO): Observable<any> {
    let url = "api/TransactionMenu/BulkTransactionUpdate";
    return this.http.post(url, getBO, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))
  
  
  }
  getAcitveAuths(paramsData: URLSearchParams): Observable<any> {
    let url = "api/TransactionMenu/getActiveAuthsWithinDateRange?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}

